import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'

Swiper.use([Navigation, Pagination])

document.querySelectorAll('.content-carousel-slider').forEach((slider) => {
  const container = slider.querySelector('.swiper')
  const numSlides = slider.querySelectorAll('.swiper-slide').length

  if (numSlides > 1) {
    new Swiper(container, {
      slidesPerView: 'auto',
      simulateTouch: false,
      spaceBetween: 20,
      loop: true,
      loopedSlides: numSlides,
      pagination: {
        el: slider.querySelector('.slider-pagination'),
        type: 'custom',
        renderCustom: (_, current, total) => {
          return `${current} of ${total}`
        },
      },
      navigation: {
        nextEl: slider.querySelector('.slider-control-next'),
        prevEl: slider.querySelector('.slider-control-prev'),
      },
    })
  }
})
